import { IAdditionalTax } from 'shared/types/additionalTax';

export class AdditionalTax {
  id: number;
  value: number;
  type: string;
  splitYooga: number;
  splitMerchant: number;
  description: string;
  fullDescription: string;
  enableWithdraw?: number;
  enabled?: boolean;

  constructor(additionalTax: IAdditionalTax) {
    this.id = additionalTax.id;
    this.value = additionalTax.value;
    this.type = additionalTax.type;
    this.splitYooga = additionalTax.splitYooga;
    this.splitMerchant = additionalTax.splitMerchant;
    this.description = additionalTax.description;
    this.fullDescription = additionalTax.fullDescription;
    this.enableWithdraw = additionalTax.enableWithdraw;
    this.enabled = additionalTax.enabled;
  }
}
